/**
 * @file: 选品组件iframe容器
 * @author: yijunjie
 * 选品组件文档: http://agroup.baidu.com/share/md/803851f29f9a473e8eb54f46692c2062
 */
import React, {useEffect, useRef, useState} from 'react';
import {Spin} from 'antd';
// import GoodsIframe from './goodsIframe';
// import {GoodsIframe} from '@baidu/eshop';
import GoodsIframe from '@baidu/eshop/lib/utils/goodsIframe';

import './index.less';

// 本地运行
// const DEV_URL = `${window.origin}/m/cecom/shop/sdk/choosegoods/index.html#/`;
// 测试环境运行
const DEV_URL = 'https://cecom.baidu.com/m/shop/sdk/choosegoods/index.html#/';
const online = window.location.host === 'huibo.baidu.com';

const IFRAME_CONFIG = {
    prod: 'huibo', // 产品线
    show: true,
    addClass: 'tb-lib-component',
    devUrl: !online && DEV_URL, // 线下调试用
    width: '100%',
    height: '100%'
};


const EshopIframe = ({onOk, type, extraParams = {}}) => {
    const [loading, setLoading] = useState(true);
    const iframeRef = useRef(null);

    useEffect(() => {
        const container = iframeRef.current;
        if (!container || !GoodsIframe) {
            return;
        }

        // 初始化iframe
        const iframeInst = new GoodsIframe({
            ...IFRAME_CONFIG,
            container,
            ...extraParams,
            from: type
        });
        const iframe = document.getElementsByClassName('pc_goods_iframe')[0];
        iframe.onload = () => {
            setLoading(false);
            container.classList.add('eshop-container-show');
        };

        iframeInst.on('add', data => {
            onOk && onOk(data);
        });
    }, []);

    return (
        <div className="eshop-iframe">
            <div ref={iframeRef} className="eshop-container" />
            {
                loading && <div className="iframe-loading"><Spin /></div>
            }
        </div>
    );
};


export default EshopIframe;
